import Image from 'next/image';

// Types
import type { PostMediaType } from '@/types/scheduler/post/media/mediaType';

export function MediaItem({ media }: { media: PostMediaType }) {
    if (media.type === 'video') {
        return (
            <video
                className="h-fit max-h-[90vh] w-fit max-w-[90vw] object-contain"
                controls
                autoPlay
                muted
                data-testid="media-overlay-video">
                <source src={media.video} type="video/mp4" />
            </video>
        );
    }

    if (media.type !== 'document') {
        return (
            <Image
                src={media?.medium_thumbnail ?? media?.min_thumbnail}
                alt=""
                className="h-fit max-h-[90vh] w-fit max-w-[90vw] object-contain"
                width={media.file_info.width}
                height={media.file_info.height}
                data-testid="media-overlay-image"
            />
        );
    }

    return null;
}
